import type { SVGProps } from 'react'
const DocumentsIconIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 40 40" {...props}>
    <path
      fill="url(#Documents_Icon_svg__a)"
      fillOpacity={0.3}
      fillRule="evenodd"
      d="M30.054 9.625c-1.666-4.43-5.942-7.582-10.954-7.582-6.411 0-11.618 5.157-11.7 11.549A9 9 0 0 0 11 30.844h16.201l.405-.008C33.382 30.623 38 25.873 38 20.044c0-4.977-3.366-9.167-7.946-10.42"
      clipRule="evenodd"
    />
    <path
      fill="#2852E4"
      fillRule="evenodd"
      d="m21.8 20.598 2.329 2.325a1.8 1.8 0 0 0 2.544-2.548l-5.082-5.074a2.25 2.25 0 0 0-3.18 0l-5.082 5.074a1.8 1.8 0 0 0 2.544 2.548l2.328-2.325V36.05a1.8 1.8 0 1 0 3.6 0z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="Documents_Icon_svg__a"
        x1={5.852}
        x2={40.58}
        y1={4.701}
        y2={27.177}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
    </defs>
  </svg>
)
export default DocumentsIconIcon
